<template>
	<v-btn
		rounded
		height="27"
		color="#ff9c00"
		depressed
		@click="$emit('click')"
	>
		<span class="assistant link ">{{$t('pages.popup.upgrade.sub')}}</span>
	</v-btn>
</template>

<script>

export default {
	name: "ToolbarUpgradeBtn",
	computed:{
		breakPoint(){
			return this.$vuetify.breakpoint.name;
		},
		maxWidth(){
			switch (this.breakPoint) {
			case "xs":
				return "60";
			case "sm":
				return "70";
			case "md":
				return "80";
			default:
				return "90";
			}
		}
	},
	methods: {
	},
};
</script>

<style scoped>

.link {
  font-weight: normal;
  font-size: 16px;
  line-height: 112.8%;
  color: #FFFBEF;
  text-align: center;
}
</style>
